import { Injectable } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { GetProductbyCategoryParam } from '../models/ParamModels/get-productby-category-param';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { SearchProductModel } from '../models/ParamModels/search-product-model';
import { MedicalServiceCategoryParams, medicalServicesParam, ProductParam, ProductTypeParam } from '../models/clinicParms/ProductTypeParam';
import { ProductPackageParam } from '../models/clinicParms/product-package-param';
import { EmailTemplateImageInput } from '../models/email-template/email-template-models';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private API_URL= environment.API_URL;
  private API_KEY = environment.API_KEY;
  
  constructor(private fb: FormBuilder, private http: HttpClient) { }
  GetProductCategories(CompanyID: Number) : any
  {
    return this.http.get<any>(this.API_URL + 'Product/GetProductCategories/' + CompanyID);
  }
  
  GetProductTypes(CompanyID: Number) : any
  {
    return this.http.get<any>(this.API_URL + 'Product/GetProductCategories/' + CompanyID);
  }
  GetProductbyCategory(getProductbyCategoryParam:GetProductbyCategoryParam) {
    return this.http.post(this.API_URL + 'Product/GetProductbyCategory',getProductbyCategoryParam).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
     )
  }
  GetProducts(CompanyID:number|null, ProductCateTypeID:number|null) : any
  {
    let params = new HttpParams();
    params = params.append('CompanyID', CompanyID);
    params = params.append('ProductCateTypeID', ProductCateTypeID);
    return this.http.get<any>(this.API_URL + 'Product/GetAllProducts',{params: params});
  }

  GetProductCateByOrderMasterIDOrPatientID(OrderMasterID:number|null, PatientID:number|null) : any
  {
    let params = new HttpParams();
    params = params.append('OrderMasterID', OrderMasterID);
    params = params.append('PatientID', PatientID);
    return this.http.get<any>(this.API_URL + 'Product/GetProductCateByOrderMasterIDOrPatientID',{params: params});
  }

  GetProductByID(ProductID:number) : any
  {
    return this.http.get<any>(this.API_URL + 'Product/GetByProduct/' + ProductID);
  }
  GetFilteredProducts(searchProductModel:SearchProductModel) {
    var opts = [];
    return opts.length ?
      of(opts) :
      this.http.post<any>(this.API_URL + 'Product/SearchProduct', searchProductModel)
        .pipe(tap(data => {
          opts = data;
        }))
  }

  GetAllHCPCQuestionCategory() : any
  {
    return this.http.get<any>(this.API_URL + 'PendingSurvey/GetAllHCPCQuestionCategory');
  }

  AddProductType(opItem:ProductTypeParam) {
    var payload = {
      "TypeID": opItem.TypeID,
      "TypeCode": opItem.TypeCode,
      "TypeDesc": opItem.TypeDesc,
      "TypeName": opItem.TypeName,
      "BranchID": opItem.BranchID,
      "UserId": opItem.UserId,
      "IsActive": opItem.IsActive,
      "IsDeleted": opItem.IsDeleted,
     };
    return this.http.post(this.API_URL + 'ClinicProduct/InsertProductType', payload).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Product Type, Something went wrong!');
        })
     );
  }

  GetProductTypesByBranchId(branchId: number) {
    return this.http.get(this.API_URL + 'ClinicProduct/GetProductTypes/'+branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Product Types, Something went wrong!');
        })
     );
  }

  AddMedicalService(opItem: medicalServicesParam) {
    return this.http.post(this.API_URL + 'ClinicProduct/InsertMedicalService', opItem).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Medical Service, Something went wrong!');
        })
     );
  }

  GetMedicalServicesByBranchId(branchId: number) {
    return this.http.get(this.API_URL + 'ClinicProduct/GetMedicalServices/'+branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Medical Services, Something went wrong!');
        })
     );
  }

  GetAllMedicalServicesByBranchId(branchId: number) {
    return this.http.get(this.API_URL + 'ClinicProduct/GetAllMedicalServices/'+branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get All Medical Services, Something went wrong!');
        })
     );
  }

  SaveMedicalServiceImage(payload: EmailTemplateImageInput): Observable<any> {
      const formData = new FormData();
      // Convert base64 string to Blob
      const blob = this.base64ToBlob(payload.uploadedFile);
      formData.append('uploadedFile', blob, 'image.png'); // filename is optional but good to add
      formData.append('branchId', payload.branchId.toString());
      return this.http.post(`${this.API_URL}ClinicProduct/SaveMedicalServiceImage`, formData
          , { responseType: 'text' }  //Extremely important for string responses! { responseType: 'text' }
      ).pipe(
            map((data: any) => data),
            catchError(error => {
                return throwError(() => new Error('Save Medical Service Image failed'));
            })
        );
  }

  AddMedicalServiceCategory(opItem: MedicalServiceCategoryParams) {
    return this.http.post(this.API_URL + 'ClinicProduct/InsertMedicalServiceCategory', opItem).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Medical Service Category, Something went wrong!');
        })
     );
  }

  GetMedicalServiceCategoriesByBranchId(branchId: number) {
    return this.http.get(this.API_URL + 'ClinicProduct/GetMedicalServiceCategories/'+branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Medical Service Categories, Something went wrong!');
        })
     );
  }

  private base64ToBlob(base64Data: string): Blob {
        const contentType = base64Data.substring(base64Data.indexOf(':') + 1, base64Data.indexOf(';'));
        const base64 = base64Data.split(',')[1];
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

  AddProduct(opItem:ProductParam) {
    if(opItem.productId > 0 && opItem.isDeleted == false){
      return this.http.post(this.API_URL + 'ClinicProduct/UpdateProduct', opItem).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Product, Something went wrong!');
        })
     );
    }
    else if(opItem.productId > 0 && opItem.isDeleted == true){
      return this.http.post(this.API_URL + 'ClinicProduct/UpdateProduct', opItem).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Product, Something went wrong!');
        })
     );
    }
    else{
      return this.http.post(this.API_URL + 'ClinicProduct/InsertProduct', opItem).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Product, Something went wrong!');
        })
     );
    }
  }

  GetProductsByBranchId(branchId: number) {
    return this.http.get(this.API_URL + 'ClinicProduct/GetProducts?branchId='+branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Products, Something went wrong!');
        })
     );
  }

  GetAllProductsByBranchId(branchId: number) {
    return this.http.get(this.API_URL + 'ClinicProduct/GetAllProducts?branchId='+branchId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Products, Something went wrong!');
        })
     );
  }
  
  AddProductPackage(opItem:ProductPackageParam) {
    var payload = {
      "packageID": opItem.packageID,
      "packageCode": opItem.packageCode,
      "packageDesc": opItem.packageDesc,
      "packageName": opItem.packageName,
      "BranchID": opItem.branchID,
      "UserId": opItem.UserId,
      "IsActive": opItem.IsActive,
      "IsDeleted": opItem.IsDeleted,
      "productIds": opItem.productIds
     };
    return this.http.post(this.API_URL + 'ClinicProduct/InsertUpdateProductPackage', payload).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Add Product Package, Something went wrong!');
        })
     );
  }
  GetProductPackagesByBranchId(branchId: number) {
    let params = new HttpParams();
    params = params.append('branchId', branchId);
    return this.http.get(this.API_URL + 'ClinicProduct/GetProductPackages', {params: params}).
      pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError('Get Product Packages, Something went wrong!');
        })
     );
  }
}
